export default __webpack_public_path__ + "static/media/gearwave.a6495ea4.png";